module.exports = __webpack_public_path__ + "static/media/so.c1561217.svg";